import { render, staticRenderFns } from "./Exit.vue?vue&type=template&id=4e54c4ac&scoped=true"
import script from "./Exit.vue?vue&type=script&lang=js"
export * from "./Exit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54c4ac",
  null
  
)

export default component.exports